import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames';
import ConfigProvider from '../../config-provider';
import { obj } from '../../util';
import Icon from '../../icon';

// 单个头像
class Avatar extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    closable: PropTypes.bool,
    img: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    prefix: 'next-',
    closable: true,
  }

  constructor(props) {
    super(props);
    this.state = {
      hoverClose: false,
    };
  }

  onHoverClose = () => {
    this.setState({
      hoverClose: true,
    });
  }

  onLeaveClose = () => {
    this.setState({
      hoverClose: false,
    });
  }

  onClose = (e) => {
    const { onClose } = this.props;
    e.stopPropagation();
    onClose();
  }

  render() {
    const { prefix, className, closable, style, img, text, onClick, ...others } = this.props;
    const { hoverClose } = this.state;
    const closeBtn = closable && (
      <Icon
        type="remove-o-fill"
        size="small"
        className={`${prefix}avatar-close`}
        onClick={this.onClose}
        onMouseEnter={this.onHoverClose}
        onMouseLeave={this.onLeaveClose}
      />
    );
    return (
      <div
        className={cls({
          [`${prefix}avatar`]: true,
          [className]: !!className,
          [`${prefix}avatar-hover-close`]: hoverClose,
        })}
        style={style}
        onClick={onClick}
        {...obj.pickAttrs(others)}
      >
        <img className={`${prefix}avatar-img`} src={img} />
        <span className={`${prefix}avatar-name`}>{text}</span>
        {closeBtn}
      </div>
    );
  }
}

export default ConfigProvider.config(Avatar);
